<template>
  <div style="position: relative">
    <v-btn
      text
      small
      @click="panel = panel === 0 ? null : 0"
      class="filter-toggle-btn"
    >
      <v-icon small class="mr-1">mdi-filter</v-icon>
      {{ activeFiltersText }}
      <v-icon small class="ml-1">{{
        panel === 0 ? "mdi-chevron-up" : "mdi-chevron-down"
      }}</v-icon>
    </v-btn>

    <v-expand-transition>
      <v-card
        v-show="panel === 0"
        class="mt-2 filter-dropdown-card"
      >
        <v-card-text class="pa-4">
          <v-form ref="form">
            <v-row dense>
              <v-col cols="12">
                <v-select
                  v-model="localFilters.status"
                  :items="statusOptions"
                  item-text="text"
                  item-value="value"
                  label="Status dokumenta"
                  clearable
                  dense
                  outlined
                  hide-details
                  class="filter-select"
                ></v-select>
              </v-col>
            </v-row>

            <v-row dense class="mt-3">
              <v-col cols="12">
                <div class="filter-section-label">Datum unosa</div>
                <DateRangeFilter
                  :from-date.sync="localFilters.insertedFrom"
                  :to-date.sync="localFilters.insertedTo"
                  from-label="Unesen od"
                  to-label="Unesen do"
                />
              </v-col>
            </v-row>

            <v-row dense class="mt-3">
              <v-col cols="12">
                <div class="filter-section-label">Datum izmjene</div>
                <DateRangeFilter
                  :from-date.sync="localFilters.modifiedFrom"
                  :to-date.sync="localFilters.modifiedTo"
                  from-label="Izmijenjen od"
                  to-label="Izmijenjen do"
                />
              </v-col>
            </v-row>

            <v-row dense class="mt-3">
              <v-col cols="12">
                <div class="filter-section-label">Datum izdavanja</div>
                <DateRangeFilter
                  :from-date.sync="localFilters.issuedFrom"
                  :to-date.sync="localFilters.issuedTo"
                  from-label="Izdano od"
                  to-label="Izdano do"
                />
              </v-col>
            </v-row>

            <v-row dense class="mt-4">
              <v-col cols="12" class="d-flex justify-end">
                <v-btn outlined @click="resetFilters" class="filter-reset-btn mr-2" small>
                  <v-icon small left>mdi-close-circle-outline</v-icon>
                  Reset
                </v-btn>
                <v-btn color="primary" @click="applyFilters" class="filter-apply-btn" small depressed>
                  <v-icon small left>mdi-check</v-icon>
                  Primijeni
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import DateRangeFilter from './DateRangeFilter.vue'

export default {
  name: 'DocumentFilters',
  components: {
    DateRangeFilter
  },
  props: {
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      panel: null,
      localFilters: {
        status: null,
        insertedFrom: null,
        insertedTo: null,
        modifiedFrom: null,
        modifiedTo: null,
        issuedFrom: null,
        issuedTo: null
      },
      statusOptions: [
        { value: 1, text: 'Na čekanju' },
        { value: 2, text: 'Na slanju' },
        { value: 3, text: 'Poslan' },
        { value: 4, text: 'Isporučen' },
        { value: 5, text: 'Odobren' },
        { value: 6, text: 'Odbijen' },
        { value: 7, text: 'Plaćen u potpunosti' },
        { value: 8, text: 'Parcijalno plaćen' },
        { value: 9, text: 'Neuspješna isporuka' }
      ]
    }
  },
  computed: {
    activeFiltersText () {
      const activeCount = this.getActiveFiltersCount()
      if (activeCount === 0) {
        return 'Nema aktivnih filtara'
      } else if (activeCount === 1) {
        return '1 aktivan filter'
      } else {
        return `${activeCount} aktivna filtera`
      }
    }
  },
  watch: {
    filters: {
      handler (newFilters) {
        this.localFilters = { ...newFilters }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    applyFilters () {
      const cleanedFilters = {}
      Object.keys(this.localFilters).forEach(key => {
        const value = this.localFilters[key]
        if (value !== null && value !== undefined && value !== '') {
          cleanedFilters[key] = value
        }
      })
      this.$emit('filters-changed', cleanedFilters)
      this.panel = null // Zatvori filter nakon primjene
    },
    resetFilters () {
      this.localFilters = {
        status: null,
        insertedFrom: null,
        insertedTo: null,
        modifiedFrom: null,
        modifiedTo: null,
        issuedFrom: null,
        issuedTo: null
      }
      this.$emit('filters-changed', {})
      this.panel = null // Zatvori filter nakon resetovanja
    },
    getActiveFiltersCount () {
      return Object.values(this.localFilters).filter(value =>
        value !== null && value !== undefined && value !== ''
      ).length
    }
  }
}
</script>

<style scoped>
/* Filter toggle button */
.filter-toggle-btn {
  height: 32px !important;
  font-size: 0.875rem !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  transition: all 0.12s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border-radius: 6px !important;
}

.filter-toggle-btn:hover {
  background: rgba(57, 137, 201, 0.1) !important;
}

/* Filter dropdown card with glass-morphism */
.filter-dropdown-card {
  position: absolute;
  right: 0;
  z-index: 200;
  min-width: 420px;
  max-width: 500px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(255, 255, 255, 0.95) 100%
  ) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(57, 137, 201, 0.2) !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(57, 137, 201, 0.15),
              0 4px 16px rgba(0, 0, 0, 0.1) !important;
}

/* Filter section label */
.filter-section-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 8px;
  letter-spacing: 0.02em;
}

/* Filter select styling */
.filter-select {
  font-size: 0.9rem !important;
}

.filter-select >>> .v-input__control {
  min-height: 40px !important;
}

.filter-select >>> .v-select__slot {
  min-height: 40px !important;
}

.filter-select >>> .v-text-field__slot {
  min-height: 40px !important;
}

.filter-select >>> fieldset {
  border-color: rgba(57, 137, 201, 0.3) !important;
  border-width: 1px !important;
  transition: all 0.15s ease !important;
}

.filter-select >>> .v-input--is-focused fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.filter-select >>> .v-label {
  font-size: 0.875rem !important;
  color: rgba(0, 0, 0, 0.6) !important;
}

/* Filter action buttons */
.filter-apply-btn {
  height: 36px !important;
  min-width: 110px !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  border-radius: 8px !important;
  background: linear-gradient(135deg, #3989C9 0%, #00B3BE 100%) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.25) !important;
  transition: all 0.12s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.filter-apply-btn:hover {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.35) !important;
  transform: translateY(-1px);
}

.filter-apply-btn:active {
  transform: translateY(0px) scale(0.98);
}

.filter-apply-btn .v-icon {
  transition: transform 0.12s ease !important;
}

.filter-apply-btn:hover .v-icon {
  transform: scale(1.15);
}

.filter-reset-btn {
  height: 36px !important;
  min-width: 100px !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  border-radius: 8px !important;
  border-color: rgba(244, 67, 54, 0.4) !important;
  color: #D32F2F !important;
  transition: all 0.12s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.filter-reset-btn:hover {
  background: rgba(244, 67, 54, 0.08) !important;
  border-color: #F44336 !important;
  transform: translateY(-1px);
}

.filter-reset-btn:active {
  transform: translateY(0px) scale(0.98);
}

.filter-reset-btn .v-icon {
  color: #D32F2F !important;
  transition: transform 0.12s ease !important;
}

.filter-reset-btn:hover .v-icon {
  transform: rotate(90deg);
}
</style>
